import { Avatar, Inline, Pill, Text } from '@7shifts/sous-chef-base';
import type { ClockUser } from '@src/api/punchTypes';
import './UserChip.css';
import { PillTheme } from '@7shifts/sous-chef-base/dist/media/Pill/types';

interface UserChipProps {
    user: ClockUser;
    statusLabel: string;
    theme?: PillTheme;
}

export function UserChip({
    user,
    statusLabel,
    theme = 'default'
}: UserChipProps) {
    const name = `${user.firstName} ${user.lastName}`.trim();
    return (
        <div className="user-chip">
            <Inline space={20} alignItems="center" flex={[0, 1, 0]}>
                <Avatar size="medium" url={user.profilePictureUrl} alt={name} />
                <Text as="h3">{name}</Text>
                <Pill theme={theme}>{statusLabel}</Pill>
            </Inline>
        </div>
    );
}
